import { render, staticRenderFns } from "./QrcodeTest.vue?vue&type=template&id=c4b2e8b4&scoped=true&"
import script from "./QrcodeTest.vue?vue&type=script&lang=js&"
export * from "./QrcodeTest.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeTest.vue?vue&type=style&index=0&id=c4b2e8b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b2e8b4",
  null
  
)

export default component.exports